var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Bj-tabs" },
    [
      _c(
        "el-tabs",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.filterRouteList.length > 1,
              expression: "filterRouteList.length > 1",
            },
          ],
          attrs: {
            value: _vm.tabValue,
            "before-leave": _vm.beforeLeave,
            type: "card",
          },
          on: { "tab-click": _vm.handleClick },
        },
        _vm._l(_vm.filterRouteList, function (item, index) {
          return _c("el-tab-pane", {
            key: index,
            attrs: {
              label: _vm.$t("route." + item.name),
              name: item.name || item.value,
            },
          })
        }),
        1
      ),
      _c("div", { staticClass: "right" }, [_vm._t("default")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }